exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset{border:0}.checkbox-required{color:#000}", ""]);

// exports
